export const environment = {
  production: true,
  version: 'v2',
  addressHostName: 'https://nominatim.openstreetmap.org',
  apiHostName: 'https://uat-api.zoeiesg.com',
  //apiHostName:'https://localhost:7261'
};
